import { render, staticRenderFns } from "./RefusedJoinIn.vue?vue&type=template&id=6071b23e&scoped=true&"
import script from "./RefusedJoinIn.vue?vue&type=script&lang=js&"
export * from "./RefusedJoinIn.vue?vue&type=script&lang=js&"
import style0 from "./RefusedJoinIn.vue?vue&type=style&index=0&id=6071b23e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6071b23e",
  null
  
)

export default component.exports